import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=2b4a9d20&"
import script from "./PaymentSummary.vue?vue&type=script&lang=js&"
export * from "./PaymentSummary.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports